import selectLocalExercise from './selectLocalExercise';
const selectInteractionBlocked = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return true;
  }
  return localExercise.checking || localExercise.settingSolution;
};
export default selectInteractionBlocked;